import { memo } from "react";

import { ComputedDatum } from "@nivo/pie";

import { PieDataProps } from "../../lib/get_src_sev_pie_data";

import {
  FindingSeverityNameToIntMap,
  SeverityToColor,
  SourceLabel,
} from "stores/FindingStore";

// -----------------------------------------------------------------------------

const PieChartTooltip = memo(function PieChartTooltip({
  datum,
}: PieChartTooltipProps) {
  const severities = Object.entries(datum.data.severity);

  //
  return (
    <div
      style={{
        background: "white",
        padding: "9px 12px",
        border: "1px solid #ccc",
      }}
    >
      <div>
        {SourceLabel[datum.data.source]}: {datum.data.value}
      </div>
      {severities.map((singleSev) => {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
            key={`sev-${singleSev[0]}-${datum.data.source}`}
          >
            <div
              style={{
                height: 10,
                width: 10,
                backgroundColor:
                  SeverityToColor[FindingSeverityNameToIntMap[singleSev[0]]],
              }}
            ></div>
            {`${singleSev[1]} ${singleSev[0]}`}
          </div>
        );
      })}
    </div>
  );
});

export default PieChartTooltip;
// -----------------------------------------------------------------------------

interface PieChartTooltipProps {
  datum: ComputedDatum<PieDataProps>;
}
